<label class="radio-button__wrapper">
  <input
    type="radio"
    [checked]="checked"
    [value]="value"
    [name]="name"
    (change)="onInput()"
    [disabled]="blocked"
  />
  <div class="radio-button"></div>
</label>
